jQuery(document).ready(function($) {
    function setIsDefaultSelected($this) {
        if ($this.find('option:selected').hasClass('heading'))
        {
            $this.addClass('default-selected');
        }
        else
        {
            $this.removeClass('default-selected');
        }
    }
    $('.form-select').each(function() {
        setIsDefaultSelected($(this));
    });
    $(document).on('change','.form-select',function() {
        setIsDefaultSelected($(this));
    });
});
function isChromium() {
    if (!! window.chrome )
        return true;
    if (navigator.userAgentData && navigator.userAgentData.brands)
    {
        for (brand_version_pair of navigator.userAgentData.brands) {
            if (brand_version_pair.brand == "Chromium"){
                return true;
            }
        }
    }
    return false;
}
if (isChromium())
{
    var x, i, j, k, l, ll, selElmnt, a, b, c;
    /* Look for any elements with the class "custom-select": */
    x = document.getElementsByClassName("select-contain");
    l = x.length;
    for (i = 0; i < l; i++) {
        selElmnt = x[i].getElementsByTagName("select")[0];
        x[i].classList.add('select-contain-active');
        ll = selElmnt.length;
        /* For each element, create a new DIV that will act as the selected item: */
        a = document.createElement("DIV");
        a.setAttribute("class", "select-selected");
        a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
        for (k  = 0; k < selElmnt.options[selElmnt.selectedIndex].classList.length; k++)
        {
            a.classList.add(selElmnt.options[selElmnt.selectedIndex].classList[k]);
        }
        if (x[i].getElementsByClassName('wpcf7-form-control-wrap').length)
        {
            x[i].getElementsByClassName('wpcf7-form-control-wrap')[0].appendChild(a);
        }
        else
        {
            x[i].appendChild(a);
        }
        /* For each element, create a new DIV that will contain the option list: */
        b = document.createElement("DIV");
        b.setAttribute("class", "select-items select-hide");
        for (j = 0; j < ll; j++) {
            /* For each option in the original select element,
            create a new DIV that will act as an option item: */
            c = document.createElement("DIV");
            c.innerHTML = selElmnt.options[j].innerHTML;
            if (selElmnt.selectedIndex == j)
                c.setAttribute('class','same-as-selected');
            for (k  = 0; k < selElmnt.options[j].classList.length; k++)
            {
                c.classList.add(selElmnt.options[j].classList[k]);
            }
            c.addEventListener("click", function(e) {
                /* When an item is clicked, update the original select box,
                and the selected item: */
                var y, i, k, l, s, h, sl, yl;
                s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                sl = s.length;
                h = this.parentNode.previousSibling;
                for (i = 0; i < sl; i++) {
                    if (s.options[i].innerHTML == this.innerHTML) {
                        s.selectedIndex = i;
                        h.innerHTML = this.innerHTML;
                        y = this.parentNode.getElementsByClassName("same-as-selected");
                        for (k = 0; k < y.length; k++) {
                            y[k].classList.toggle("same-as-selected");
                        }
                        break;
                    }
                }
                this.classList.add('same-as-selected');
                h.click();
            });
            b.appendChild(c);
        }
        if (x[i].getElementsByClassName('wpcf7-form-control-wrap').length) {
            x[i].getElementsByClassName('wpcf7-form-control-wrap')[0].appendChild(b);
        }
        else {
            x[i].appendChild(b);
        }
        a.addEventListener("click", function(e) {
            /* When the select box is clicked, close any other select boxes,
            and open/close the current select box: */
            e.stopPropagation();
            closeAllSelect(this);
            this.nextSibling.classList.toggle("select-hide");
            this.classList.toggle("select-arrow-active");
            this.parentNode.classList.toggle('select-arrow-active');
        });
    }

    function closeAllSelect(elmnt) {
        /* A function that will close all select boxes in the document,
        except the current select box: */
        var x, s, y, i, xl, yl, arrNo = [];
        x = document.getElementsByClassName("select-items");
        y = document.getElementsByClassName("select-selected");
        xl = x.length;
        yl = y.length;
        for (i = 0; i < yl; i++) {
            if (elmnt == y[i]) {
                arrNo.push(i);
            } else {
                y[i].classList.remove("select-arrow-active");
                y[i].classList.remove("heading");
                s = y[i].parentNode.getElementsByTagName("select")[0];
                for (k  = 0; k < s.options[s.selectedIndex].classList.length; k++)
                {
                    y[i].classList.add(s.options[s.selectedIndex].classList[k]);
                }
                y[i].parentNode.classList.remove("select-arrow-active");
            }
        }
        for (i = 0; i < xl; i++) {
            if (arrNo.indexOf(i)) {
                x[i].classList.add("select-hide");
            }
        }
    }

    /* If the user clicks anywhere outside the select box,
    then close all select boxes: */
    document.addEventListener("click", closeAllSelect);
}